module.exports = __webpack_public_path__ + "img/350-05ff05.png";